// extracted by mini-css-extract-plugin
module.exports = {"Security":"style_Security__2cTWx","Tittle":"style_Tittle__3j5iU","DisconectInfo":"style_DisconectInfo__A8Oy3","DisconectBtn":"style_DisconectBtn__1fExj"};